import { Pipe, PipeTransform } from "@angular/core";
import { Telefono } from "../../components/telefono/telefono.component";

@Pipe({ name: 'telefono' })
export class TelefonoPipe implements PipeTransform {

  transform(value: Telefono | string): string {
    if (value && typeof value != 'string') {
      let telefono = '';
      if (value.pais.length > 0) {
        telefono += '(+' + value.pais + ')';
        if (value.area.length > 0 || value.numero.length > 0) {
          telefono += ' ';
        }
      }
      if (value.area.length > 0) {
        telefono += value.area;
        if (value.numero.length > 0) {
          telefono += ' - ';
        }
      }
      if (value.numero.length > 0) {
        telefono += value.numero;
      }

      return telefono;
    } else if (value && typeof value == 'string' && value.indexOf('|') > -1) {
      let valores = value.split('|');
      const pais = valores[0] ? valores[0] : '';
      const area = valores[1] ? valores[1] : '';
      const numero = valores[2] ? valores[2] : '';
      const telefonoFormateado = (new Telefono(pais, area, numero));
      return this.transform(telefonoFormateado);
    }

    return '';
  }
}